<div data-test-automation="tenure-parent-plan-number">
    @if (['EDIT_INFORMATION', 'VIEW_INFORMATION'] | hasPermissions) {
        <div>
            <label class="control-label required-input">{{label}}</label>
            <div
                class="input-group"
                [ngClass]="{'has-error': (parentPlanNumberInput | formFieldHasError) || parentPlanNumberInput?.errors?.['nlrPattern']}">
                <span class="input-group-addon">
                    <i class="nlrp-icon nlrp-icon-edit"></i>
                </span>
                <input
                    type="number"
                    [name]="'parentPlanNumber'+name"
                    [id]="'parentPlanNumber'+name"
                    class="form-control"
                    #parentPlanNumberInput="ngModel"
                    id="parentPlanNumber"
                    [disabled]="readonly || (['EDIT_INFORMATION', 'VIEW_INFORMATION'] | disabledByPermissions)"
                    [nlrPattern]="planPattern"
                    [(ngModel)]="tenure.parentPlan"
                    required
                    data-test-automation="tenure-parent-plan-number" />
            </div>
            @if (parentPlanNumberInput?.errors?.['nlrPattern']) {
                <div class="help-block">
                    <span>Error!</span>
                    <span>Invalid</span>
                </div>
            }
        </div>
    }
</div>
